/**
 * Copyright 2025 IBM Corp.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import cryptoJs from "crypto-js";

export function createHash(input: string, length = 4) {
  return cryptoJs.SHA256(input).toString().substring(0, length);
}

export function createRandomHash(length = 4) {
  return cryptoJs.SHA256(Date.now().toString()).toString().substring(0, length);
}
